import { variant } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { buttonShadows } from '../components/buttonShadows';

export function getDestructiveEmphasisVariant() {
    return variant({
        prop: 'emphasis',
        variants: {
            high: {
                color: theme.colors.foreground.onEmphasis,
                background: `linear-gradient(0deg, ${theme.colors.negative.emphasis}, ${theme.colors.negative.emphasis}, #FF6984)`,
                borderStyle: 'none',
                padding: '4px 8px',
                backgroundSize: '200% 200%',
                backgroundPosition: '0% 0%',
                transition: 'background-position 100ms ease-out',
                boxShadow: `${buttonShadows.emphDrop}, ${buttonShadows.destructiveBorder}`,

                '&:hover': {
                    backgroundPosition: '100% 100%',
                    boxShadow: `${buttonShadows.emphDrop}, ${buttonShadows.destructiveBorderHover}, ${buttonShadows.dropHover}`,
                },
                '&:focus': {
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.emphDrop},
                        ${buttonShadows.destructiveBorderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.negative.foreground,
                    boxShadow: `${theme.shadows.focus}, ${buttonShadows.emphDrop}, ${buttonShadows.destructiveBorder}, ${buttonShadows.dropHover}`,
                },
                '&:disabled': {
                    background: theme.colors.negative.border,
                    boxShadow: `${buttonShadows.destructiveBorderDisabled}`,
                },
            },
            medium: {
                color: theme.colors.negative.foreground,
                background: `linear-gradient(0deg, ${theme.colors.background.subtle}, ${theme.colors.background.subtle}, ${theme.colors.background.default})`,
                boxShadow: `0px 1px 1px 0px rgba(25, 54, 67, 0.16) ,${theme.shadows.border.default}`,
                padding: '4px 8px',
                backgroundSize: '200% 200%',
                backgroundPosition: '0% 0%',
                transition: 'background-position 100ms ease-out, box-shadow 100ms ease-in-out',

                '&:hover': {
                    backgroundPosition: '100% 100%',
                    boxShadow:
                        '0px 1px 1px 0px rgba(25, 54, 67, 0.16), 0px 0px 0px 1px #B0C8D2, 0px 2px 4px 0px rgba(25, 54, 67, 0.08)',
                },
                '&:focus': {
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${buttonShadows.borderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                },
            },
            low: {
                color: theme.colors.negative.foreground,
                background: 'transparent',
                borderStyle: 'none',
                padding: '4px 8px',

                '&:hover': {
                    background: theme.colors.background.subtle,
                },
                '&:focus': {
                    background: theme.colors.background.subtle,
                    boxShadow: `${theme.shadows.focus},
                        ${buttonShadows.drop},
                        ${buttonShadows.borderHover},
                        ${buttonShadows.dropHover}`,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                },
            },
            none: {
                color: theme.colors.foreground.default,
                background: 'transparent',
                borderStyle: 'none',
                padding: '4px 8px',

                '&:hover': {
                    background: theme.colors.background.subtle,
                },
                '&:active': {
                    background: theme.colors.background.inset,
                },
            },
        },
    });
}
